// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { ProductMustTryCard } from 'Components/widgets/product-must-try-card/ProductMustTryCard.jsx';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable.jsx';

type Props = {
  className?: string,
  isFrench?: boolean,
  items: Array<{
    description: string,
    id: string,
    imageSrc: string,
    seeMoreLabel?: string,
    title: string,
    trackingData?: TrackingData,
  }>,
  productColor: Colors,
  productIconName: IconName,
  scrollBackwardLabel?: string,
  scrollForwardLabel?: string,
};

export function ProductMustTryNarrow(props: Props) {
  const {
    className,
    isFrench,
    items = [],
    productColor,
    productIconName,
    scrollBackwardLabel,
    scrollForwardLabel,
  } = props;

  return (
    <div className={classnames(className, 'relative')}>
      <div
        className={`absolute bg-${productColor} p-5 inset-0 text-center`}
        style={{ height: '24.375rem' }}
      >
        <div className="absolute opacity-25 top-0 rtl:left-0 pt-3">
          <Icon color={COLORS.BLACK} isNotSquare name={productIconName} width="8.75rem" />
        </div>
        <Icon
          color={COLORS.WHITE}
          name={isFrench ? ICONS.MUST_TRY_EXPERIENCES_FR : ICONS.MUST_TRY_EXPERIENCES}
          width={isFrench ? '12.5rem' : '10rem'}
        />
      </div>
      <Scrollable
        backwardLabel={scrollBackwardLabel}
        className="pt-24"
        forwardLabel={scrollForwardLabel}
        navPosition="center"
      >
        <div className="flex px-3">
          {items.map(({ description, id, imageSrc, seeMoreLabel, title, trackingData }) => (
            <div key={id} className="flex-none m-2" style={{ width: '280px' }}>
              <ProductMustTryCard
                description={description}
                imageSrc={imageSrc}
                seeMoreLabel={seeMoreLabel}
                title={title}
                trackingData={trackingData}
              />
            </div>
          ))}
          <div className="pr-3" />
        </div>
      </Scrollable>
    </div>
  );
}
